import { TypeAheadItem } from "../../controls";
import { FigureData } from "../types/FigureData";
import { FigureSettings } from "../types/FigureSettings";

export interface BeFigureState {
  figureInput: FigureData;
  figureSettings: FigureSettings;
  varNames: TypeAheadItem[];
  changed: boolean;
  savedFigureData?: Record<string, Partial<FigureData>>;
}

export const ADD_DATA_GROUP = "ADD_DATA_GROUP";
export const ADD_PROPERTY = "ADD_PROPERTY";
export const ADD_REFERENCE_LINE = "ADD_REFERENCE_LINE";
export const ADD_REGRESSION_LINE = "ADD_REGRESSION_LINE";
export const CHANGE_REGRESSION_LINE_TYPE = "CHANGE_REGRESSION_LINE_TYPE";
export const FIGURE_CHANGE_SENT = "FIGURE_CHANGE_SENT";
export const LOAD_FIGURE_INPUT = "LOAD_FIGURE_INPUT";
export const PATCH_FIGURE_STATE = "PATCH_FIGURE_STATE";
export const REMOVE_FIGURE_ITEM = "REMOVE_FIGURE_ITEM";
export const SET_FIGURE_TYPE = "SET_FIGURE_TYPE";
export const SET_LEGEND_TYPE = "SET_LEGEND_TYPE";

export interface FigureReducerActionAddDataRow {
  operation: typeof ADD_DATA_GROUP;
  newLength: number;
}

export interface FigureReducerActionAddProperty {
  operation: typeof ADD_PROPERTY;
  pointer: string;
  varName: string;
}

export interface FigureReducerActionAddReferenceLine {
  operation: typeof ADD_REFERENCE_LINE;
  newLength: number;
}

export interface FigureReducerActionAddRegressionLine {
  operation: typeof ADD_REGRESSION_LINE;
  newLength: number;
}

export interface FigureReducerActionChangeRegressionLineType {
  operation: typeof CHANGE_REGRESSION_LINE_TYPE;
  pointer: string;
  lineType: string;
}

export interface FigureReducerActionChangeSent {
  operation: typeof FIGURE_CHANGE_SENT;
}

export interface FigureReducerActionLoadFigureInput {
  operation: typeof LOAD_FIGURE_INPUT;
  figureInput: FigureData;
}

export interface FigureReducerActionPatchValue {
  operation: typeof PATCH_FIGURE_STATE;
  pointer: string;
  value: string;
}

export interface FigureReducerActionRemoveArrayItem {
  operation: typeof REMOVE_FIGURE_ITEM;
  dataPath: string;
}

export interface FigureReducerActionSetFigureType {
  operation: typeof SET_FIGURE_TYPE;
  newValue: string;
}

export interface FigureReducerActionSetLegendType {
  operation: typeof SET_LEGEND_TYPE;
  newValue: string;
}

export type BeFigureAddOperations =
  | typeof ADD_DATA_GROUP
  | typeof ADD_REFERENCE_LINE
  | typeof ADD_REGRESSION_LINE;

export type BeFigureAction =
  | FigureReducerActionAddDataRow
  | FigureReducerActionAddProperty
  | FigureReducerActionAddReferenceLine
  | FigureReducerActionAddRegressionLine
  | FigureReducerActionChangeRegressionLineType
  | FigureReducerActionChangeSent
  | FigureReducerActionLoadFigureInput
  | FigureReducerActionPatchValue
  | FigureReducerActionRemoveArrayItem
  | FigureReducerActionSetFigureType
  | FigureReducerActionSetLegendType;
